import React, { useEffect, useState } from 'react';
import classes from "./XOGameOver.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import { getProfile } from '../http/http';
import RewardsAnimation from "../animations/rewards.json";
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import Header from '../components/Header';
import { resetIndex } from '../store/slices/wordGameSlice/activeTileSlice';
import { resetTiles } from '../store/slices/wordGameSlice/tileWordSlice';
import { resetEnteredWords } from '../store/slices/wordGameSlice/enteredWordSlice';
import { resetTargetWord } from '../store/slices/wordGameSlice/targetWordSlice';
import { resetTargetWord3 } from '../store/slices/wordGameSlice/targetWord3Slice';
import { resetWord3Result } from '../store/slices/wordGameSlice/word3Result';
import { resetWordResult } from '../store/slices/wordGameSlice/wordResult';
import { ResetTime, ResetTimeForProgress } from '../store/slices/wordGameSlice/wordTimeSlice';
import { reset } from '../components/XOGame/utils/gameFunctions';

const XOGameOver = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [userProfile, setUserProfile] = useState(null);

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (!location?.state?.result) {
            navigate("/home");
        }
    }, [location?.state]);

    const fetchUserProfile = async () => {
        try {
            const response = await getProfile(userToken);
            setUserProfile(response?.data?.result);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchUserProfile();
    }, []);

    /* PREVENT THE USER FROM CLICKING BACK BUTTON OF BROWSER... */
    useEffect(() => {
        window.history.pushState(null, null, document.URL);
        window.addEventListener("popstate", function () {
            window.history.pushState(null, null, document.URL);
        });
    }, [window]);

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("39")}</h2>
                </div>

                {location?.state?.result == "win" ? (<>
                    <div className={classes.modal_img_container}>
                        <img
                            className={classes.modal_img}
                            src="/assets/images/happy.png"
                            alt="result"
                        />
                    </div>
                    <div className={classes.modal_description}>
                        <h1>Congratulations...</h1>
                        <p>You won!</p>
                        {/* <p>The word was {location?.state?.word}</p> */}
                    </div>
                </>) : location?.state?.result == "lose" ? (<>
                    <div className={classes.modal_img_container}>
                        <img
                            className={classes.modal_img}
                            src="/assets/images/game_over.png"
                            alt="result"
                        />
                    </div>
                    <div className={classes.modal_description}>
                        <h1>OOPS...</h1>
                        <p>You have lost the game!</p>
                        {/* <p>{location?.state?.winner}</p> */}
                    </div>
                </>) : (
                    <>
                        <div className={classes.modal_img_container}>
                            <img
                                className={classes.modal_img}
                                src="/assets/images/game_over.png"
                                alt="result"
                            />
                        </div>
                        <div className={classes.modal_description}>
                            <h1>Draw</h1>
                        </div>
                    </>
                )}


                <div className={classes.points_container_center}>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation_reward} />
                        </div>
                        <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                    </div>
                </div>

                <div className={classes.buttons_container}>
                    <button
                        type="button"
                        className={classes.play_btn}
                        // onClick={closeModalHandler}
                        onClick={() => {
                            reset(dispatch);

                            navigate("/xo-game", {
                                state: {
                                    level: location?.state?.level
                                }
                            })
                        }}
                    >
                        Play Again!
                    </button>
                    <button
                        type="button"
                        className={classes.back_btn}
                        onClick={() => navigate("/home")}
                    // onClick={goBack}
                    >
                        Go Back!
                    </button>
                </div>


            </div>
        </>
    )
}

export default XOGameOver;